import Vue from 'vue'

let VueCookie = require('vue-cookie');

Vue.use(VueCookie);
